type PNExceptionCodeDefinition = {
    message: string
    isExitException?: boolean
}

function define(message: string): PNExceptionCodeDefinition {
    return {
        message,
    }
}

function defineExitException(message: string): PNExceptionCodeDefinition {
    return {
        message,
        isExitException: true,
    }
}

/** @public */
export enum PNExceptionCode {
    EXCEPTION = 'exception',

    DUPLICATE_SDK_DETECTED = 'duplicate_sdk_detected',
    SDK_ALREADY_LOADED = 'sdk_already_loaded',

    DOMAIN_CONFIGURATION_LOAD_FAILED = 'domain_config_load_failed',
    HOST_NOT_ALLOWED = 'host_not_allowed',
    PROMPTS_LOAD_FAILED = 'prompts_load_failed',

    WEB_PUSH_NOT_SUPPORTED = 'web_push_not_supported',
    WEB_PUSH_CONFIGURATION_MISSING = 'web_push_config_missing',
    WEB_PUSH_SUBSCRIPTION_FAILED = 'web_push_subscription_failed',
    PUSH_WORKER_NOT_FOUND_EXCEPTION = 'push_worker_not_found_exception',
    PUSH_WORKER_REGISTRATION_EXCEPTION = 'push_worker_registration_exception',
    PUSH_WORKER_SUBSCRIPTION_EXCEPTION = 'push_worker_subscription_exception',

    STORAGE_NOT_AVAILABLE = 'storage_not_available',
    STORAGE_FAILED_TO_OPEN = 'storage_failed_to_open',
    STORAGE_NS_REQUIRED = 'storage_ns_required',
    STORAGE_KEY_EMPTY = 'storage_key_empty',
    IDB_INVALID_STORE_NAME = 'idb_invalid_store_name',
    IDB_BLOCKED = 'idb_blocked',

    REQUEST_FAILED = 'request_failed',
    REQUEST_URL_INVALID = 'request_url_invalid',
    REQUEST_NO_RESULT = 'request_no_result',
    REQUEST_DESERIALIZATION_FAILED = 'request_deserialization_failed',

    // DEBUG ERRORS

    UNKNOWN_CONTEXT_KEY = 'unknown_context_key',
    UNKNOWN_CONFIG_KEYS = 'unknown_config_keys',
    UNKNOWN_ASYNC_COMMAND = 'unknown_async_command',
    UNKNOWN_PROMPT_MESSAGE = 'unknown_prompt_message',

    WORKER_MISSING_PUSH_DATA = 'worker_missing_push_data',
    UNKNOWN_WORKER_PUSH = 'unknown_worker_push',
    UNKNOWN_WORKER_PUSHLY_INTERACTION = 'unknown_worker_pushly_interaction',
    UNKNOWN_WORKER_3P_INTERACTION = 'unknown_worker_3p_interaction',
}

/** @internal */
export const PNExceptionCodeMap: Record<PNExceptionCode, PNExceptionCodeDefinition> = {
    [PNExceptionCode.EXCEPTION]: define('Unknown exception'),

    [PNExceptionCode.DUPLICATE_SDK_DETECTED]: defineExitException('Another instance of the SDK is already running'),
    [PNExceptionCode.SDK_ALREADY_LOADED]: defineExitException('The SDK has already been loaded'),

    [PNExceptionCode.DOMAIN_CONFIGURATION_LOAD_FAILED]: defineExitException(
        'Failed to load Domain configuration from remote',
    ),
    [PNExceptionCode.HOST_NOT_ALLOWED]: defineExitException('Current host is not allowed for use'),
    [PNExceptionCode.PROMPTS_LOAD_FAILED]: define('Failed to load Prompts from remote'),

    [PNExceptionCode.WEB_PUSH_NOT_SUPPORTED]: defineExitException('Web push not supported'),
    [PNExceptionCode.WEB_PUSH_SUBSCRIPTION_FAILED]: define('Error encountered during subscription'),
    [PNExceptionCode.WEB_PUSH_CONFIGURATION_MISSING]: defineExitException('Web push configuration missing'),
    [PNExceptionCode.PUSH_WORKER_NOT_FOUND_EXCEPTION]: define('Service Worker file not found'),
    [PNExceptionCode.PUSH_WORKER_REGISTRATION_EXCEPTION]: define('Service Worker registration exception encountered'),
    [PNExceptionCode.PUSH_WORKER_SUBSCRIPTION_EXCEPTION]: define('Web push subscription exception encountered'),

    [PNExceptionCode.STORAGE_NOT_AVAILABLE]: define('Storage not available'),
    [PNExceptionCode.STORAGE_FAILED_TO_OPEN]: define('Storage failed to open'),
    [PNExceptionCode.STORAGE_NS_REQUIRED]: define('Store name is required'),
    [PNExceptionCode.STORAGE_KEY_EMPTY]: define('No data for storage key'),
    [PNExceptionCode.IDB_INVALID_STORE_NAME]: define('IndexedDB requires a valid store name; `null` provided'),
    [PNExceptionCode.IDB_BLOCKED]: define('IndexedDB is blocked'),

    [PNExceptionCode.REQUEST_FAILED]: define('Request exception encountered'),
    [PNExceptionCode.REQUEST_URL_INVALID]: define('Invalid URL'),
    [PNExceptionCode.REQUEST_NO_RESULT]: define('No result'),
    [PNExceptionCode.REQUEST_DESERIALIZATION_FAILED]: define('Failed to decode response'),

    // DEBUG ERRORS

    [PNExceptionCode.UNKNOWN_CONTEXT_KEY]: define('Unknown context key'),
    [PNExceptionCode.UNKNOWN_CONFIG_KEYS]: define('Unknown configuration key'),
    [PNExceptionCode.UNKNOWN_ASYNC_COMMAND]: define('Unknown pushly() command'),
    [PNExceptionCode.UNKNOWN_PROMPT_MESSAGE]: define('Unknown prompt message'),

    [PNExceptionCode.WORKER_MISSING_PUSH_DATA]: define('Push event data missing'),
    [PNExceptionCode.UNKNOWN_WORKER_PUSH]: define('Unknown worker push event'),
    [PNExceptionCode.UNKNOWN_WORKER_PUSHLY_INTERACTION]: define('Unknown worker pushly interaction'),
    [PNExceptionCode.UNKNOWN_WORKER_3P_INTERACTION]: define('Unknown worker 3rd-party interaction'),
}
